import { createFileRoute } from '@tanstack/react-router';

import {
  loadSimulationMessages,
  loadSimulationOffersScreens,
  simulationPrivatePayrollNewScreen,
} from '@/modules/simulation/route';
import { flowSearchSchema } from '@/shared/flow/define-flow';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Consignado privado novo no caminho do legado (`router.tsx:1156-1160`, `resource='ConsignadoPrivado'`): o passo vai
// em `?passo=`. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/ccb/contratar/consignado-privado/novo/')({
  validateSearch: flowSearchSchema(),
  staticData: { screen: simulationPrivatePayrollNewScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationOffersScreens, 'PrivatePayrollRouteScreen'),
});
